import { useEffect, useState } from "react";
import { SnackbarNotice } from "@/shared/notifications/SnackbarNotice";

/** Illegal attempts are local to one displayed position, never persistent engine errors. */
export const useBoardNotice = (positionKey: string) => {
  const [message, setMessage] = useState<{ key: string; text: string } | null>(null);
  useEffect(() => {
    if (!message) return;
    const timer = window.setTimeout(() => setMessage(null), 3000);
    return () => window.clearTimeout(timer);
  }, [message]);
  useEffect(() => setMessage(null), [positionKey]);
  return {
    notify: (text = "That move is not legal in this position.") => setMessage({ key: positionKey, text }),
    notice: message?.key === positionKey ? <SnackbarNotice severity="info">{message.text}</SnackbarNotice> : null,
  };
};
